<template>
  <b-container fluid>
    <b-row style="padding-top: 2em;">
      <b-col>
        <b-button
          v-if="isSystemAdmin"
          variant="success"
          v-on:click="newProject">
          New Project
        </b-button>
        <EditProjectModal
          ref="new-project-modal"
          :mode="'Add'"
          @submit="newProjectSubmit">
        </EditProjectModal>
      </b-col>
    </b-row>
    <LoadingIndicator 
      v-if="loading"
      topic="Projects"
    />
    <div v-else>
      <BaseMessageBlock type="Success" :messages="messages"></BaseMessageBlock>
      <!-- <b-row v-for="index in projectRows" class="display-flex" style="padding-top: 1em;" :key="index">
        <ProjectItem :summary="projects[2 * (index - 1)]" />
        <ProjectItem :summary="projects.length >= index ? projects[2 * index - 1] : undefined" />
      </b-row> -->
      <b-row v-for="project in projects" class="display-flex" style="padding-top: 1em;" :key="project.projectId">
        <ProjectItem :summary="project" />
      </b-row>
      <b-row v-if="projects.length === 0">
        <b-col>
          <p>No projects!</p>
        </b-col>
      </b-row>
    </div>
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
  </b-container>
</template>

<script>
import axios from "axios";
import ProjectItem from "@/sub-components/ProjectItem.vue";
import EditProjectModal from "@/modal-components/EditProjectModal.vue";

export default {
  components: {
    ProjectItem,
    EditProjectModal
  },
  data() {
    return {
      errors: [],
      messages: [],
      loading: false,
      projects: []
    };
  },
  mounted() {
    this.loadProjects();

    if (this.$route.query.setup == 'true') {
      this.messages.push({ message: "You're all set!"});
      this.messages.push({ message: "Be on the lookout for your monthly project surveys."});
      this.messages.push({ message: '<a href="https://support.microsoft.com/en-ie/office/add-recipients-of-my-email-messages-to-the-safe-senders-list-be1baea0-beab-4a30-b968-9004332336ce">For best results, add info@dashtech.app to your safe senders list.</a>'});
    }
  },
  methods: {
    newProject() {
      this.$refs['new-project-modal'].show();
    },
    newProjectSubmit(projectId) {
      this.$router.push({
        name: "New Survey",
        query: { pid: projectId }
      });
    },
    loadProjects(){
      this.loading = true;
      //Load projects by userId
      axios
        .get(`${this.$api_url}/users/${this.accountUser.userId}/project-summaries`,
          this.getReqConfig())
        .then(response => {
          this.projects = response.data;
          let ordering = ["Open", "Closed"]
          this.projects.sort((a, b) =>
            ordering.indexOf(a.project.status) > ordering.indexOf(b.project.status) ? 1 : -1);
            
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loading = false;
      });
    }
  },
  computed: {
    projectRows() {
      return Math.floor((this.projects.length + 1) / 2);
    },
  }
};
</script>
<style scoped>
.row.display-flex {
  display: flex;
  flex-wrap: wrap;
}
.row.display-flex > [class*="col-"] {
  display: flex;
  flex-direction: column;
}
</style>
